import { useEffect, useState } from "react";
import { fetchUserAttendance } from "../Api/ViewUserAttendance";
import { fetchWorkingDaysData } from "../Api/UserAttendance";
import { Container, Table, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";

const ViewUserAttendance = () => {
  const { user } = useAuth();

  const [attendance, setAttendance] = useState([]);
  const [workingDays, setWorkingDays] = useState([]);
  const [selectedWorkingDaysId, setSelectedWorkingDaysId] = useState("");

  /* ------------------ LOAD WORKING DAYS ------------------ */
  useEffect(() => {
    const loadWorkingDays = async () => {
      try {
        const res = await fetchWorkingDaysData(user?.organisationId);
        setWorkingDays(res || []);
      } catch {
        toast.error("Failed to load working days");
      }
    };

    loadWorkingDays();
  }, [user]);

  /* ------------------ LOAD ATTENDANCE ------------------ */
  useEffect(() => {
    const loadAttendance = async () => {
      try {
        const data = await fetchUserAttendance(selectedWorkingDaysId);
        setAttendance(data || []);
      } catch {
        toast.error("🦄No User Attendance for this working month");
        setAttendance([]);
      }
    };

    loadAttendance();
  }, [selectedWorkingDaysId]);

  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <span className="list-title">View User Attendance</span>

        {/* ---------- WORKING DAYS DROPDOWN ---------- */}
        <Form.Group className="mb-3 mt-3" style={{ maxWidth: "300px" }}>
          <Form.Label>Working Month</Form.Label>
          <Form.Select
            value={selectedWorkingDaysId}
            onChange={(e) => setSelectedWorkingDaysId(e.target.value)}
          >
            
            {workingDays.map((item) => (
              <option key={item.workingDaysId} value={item.workingDaysId}>
                {item.workingMonth}-{item.workingYear}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* ---------- TABLE ---------- */}
        {attendance.length > 0 ? (
          <div className="table-wrapper">
            <div className="table-scroll-container">
              <Table bordered hover className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Attendance ID</th>
                    <th>Working Days ID</th>
                    <th>Resource Name</th>
                    <th>Resource ID</th>
                    <th>Salary Days</th>
                    {/* <th>Payroll ID</th> */}
                    {/* <th>Created At</th>
                    <th>Created By</th> */}
                  </tr>
                </thead>
                <tbody>
                  {attendance.map((record, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{record?.attendence?.attendenceId}</td>
                      <td>{record?.attendence?.workingDaysId}</td>
                      <td>{record?.resource?.name}</td>
                      <td>{record?.attendence?.resourceId}</td>
                      <td>{record?.attendence?.salaryDays}</td>
                      {/* <td>{record?.attendence?.payrollid}</td> */}
                      {/* <td>
                        {record.createdAt
                          ? `${moment(record.createdAt).format("L")} at ${moment(
                              record.createdAt
                            ).format("LTS")}`
                          : "N/A"}
                      </td> */}
                      {/* <td>{record.createdBy || "N/A"}</td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <p className="no-data">No attendance records found.</p>
        )}
      </Container>
    </div>
  );
};

export default ViewUserAttendance;
